
import React, { Component } from 'react';
import coursesImg from "../images/courses.jpg"

export default class Courses extends Component {
  componentDidMount(){
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
  }
    render() {

    return (

      <section className="home-course-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="career-panel row"> 
                <div className='col-lg-6'>
                  <div className="home-head py-5">Problems with course selection today
                    {/* <p>Live Online Masterclass.</p> */}
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className="get-accordian">
                    <div className='accordion-list'>
                      <button className="accordion active">
                        <span>Random Results</span>
                      </button>
                      <div className="panel" style={{display:"block"}}>
                      Since internet search is not customized, browsing for something means you will be hit with way more results than you can handle.
                      </div>
                    </div>
                    <div className='accordion-list'>
                      <button className="accordion">
                        <span>Bias</span>
                      </button>
                      <div className="panel">
                      More often than not, course portals are sponsored, making them inherently biased.      
                      </div>
                    </div>
                    <div className='accordion-list'>
                      <button className="accordion">
                        <span>Prejudice</span>
                      </button>
                      <div className="panel">
                        Recommendations from peers are influenced by personal bias, making them incompatible with your needs.
                      </div>
                    </div>
                    <div className='accordion-list'>
                      <button className="accordion">
                        <span>Information Overload</span>
                      </button>
                      <div className="panel">
                      Millions of course promotions suffer from hard-selling. Even if you know what you want, it is impossible not to be distracted by some of them.
                      </div>
                    </div>
                    <div className='accordion-list'>
                      <button className="accordion">
                        <span>Non Personalized</span>
                      </button>
                      <div className="panel">
                      Course portals do not factor your individual traits into the search. As a result, the offered courses are generic and superficial at best.                    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
      )
    }
}


// WEBPACK FOOTER //
// ./src/home/courses.jsx